import { List } from "@mui/material";
import { useContext, useMemo, useState } from "react";
import useAPI from "../../../../../../api/hooks/useAPI";
import { CustomerFeatureFlagsContext } from "../../../../../../contexts/CustomerFeatureFlagsContext";
import AuditLogsModal from "./AuditLogsModal";
import RemediationAuditLog from "./RemediationAuditLog";
import RemediationCollapseSection from "./RemediationCollapseSection";
import AutoRemediationDrawerLog from "./autoRemediation/AutoRemediationDrawerLog";

export default function AuditLogsSection({ auditLogs }) {
  const { trackEvent } = useAPI();
  const [auditLogOpen, setAuditLogOpen] = useState(false);
  const [selectedAuditLog, setSelectedAuditLog] = useState(null);
  const { autoRemediationActive } = useContext(CustomerFeatureFlagsContext);

  const sortedLogs = useMemo(() => {
    return [...auditLogs].sort((a, b) => {
      // Sort by timestamp in descending order (latest first)
      const dateA = new Date(a.log_timestamp.timestamp_utc).getTime();
      const dateB = new Date(b.log_timestamp.timestamp_utc).getTime();
      return dateB - dateA;
    });
  }, [auditLogs]);

  const onAuditLogClick = (log) => {
    trackEvent(`User clicked on remediation audit log ${log?.log_id}`);
    setSelectedAuditLog(log);
    setAuditLogOpen(true);
  };

  return (
    <>
      <RemediationCollapseSection title="Auto-Remediation History">
        <List>
          {sortedLogs.map((log, index) => {
            if (autoRemediationActive) {
              return (
                <AutoRemediationDrawerLog
                  key={log.log_id}
                  auditLog={log}
                  isMostRecentLog={index === 0}
                  showTopConnectLine={index !== 0}
                  showBottomConnectLine={index !== sortedLogs.length - 1}
                />
              );
            } else {
              return (
                <RemediationAuditLog
                  key={log.log_id}
                  auditLog={log}
                  onMoreDetails={() => onAuditLogClick(log)}
                  showTopConnectLine={index !== 0}
                  showBottomConnectLine={index !== sortedLogs.length - 1}
                />
              );
            }
          })}
        </List>
      </RemediationCollapseSection>

      <AuditLogsModal
        open={auditLogOpen}
        onClose={() => setAuditLogOpen(false)}
        log={selectedAuditLog}
      />
    </>
  );
}
